var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPiechartFilled = function SvgPiechartFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M4.943 1.488c.49-.303 1.107-.03 1.3.514l1.835 5.173c.152.427.463.779.868.982l4.942 2.47c.515.258.711.902.352 1.352A7.116 7.116 0 1 1 4.943 1.488Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M8.488 1.84c-.413.012-.66.435-.522.825L9.4 6.706a.35.35 0 0 0 .173.197l3.934 1.966c.333.167.738-.008.8-.376A5.714 5.714 0 0 0 8.489 1.84Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPiechartFilled);
export default ForwardRef;